export default __webpack_public_path__ + "static/media/spotify_logo.1a4df584.svg";